module.exports = __webpack_public_path__ + "media/img/automated-testing/automated-banner-icon-1ea260eae04434401d1b2cfcad44db47.svg";